<template>
  <div class="editPage">
    <qx-card :title="pageTitle">
      <BaseForm ref="baseForm" />
    </qx-card>
    <SubBtnBox @sub="sub" />
  </div>
</template>

<script>
import BaseForm from './base';
import SubBtnBox from 'components/subBtnBox';
import {
  orgEdit,
  orgDetail,
} from 'api/system';
import pageDataMixin from '@qx/mixin/pageData';
export default {
  mixins: [
    pageDataMixin,
  ],
  components: {
    BaseForm,
    SubBtnBox,
  },
  data () {
    return {
      pageUrl: '/manage/system/jurisdiction/organization/edit',
      formComponents: ['baseForm'],
      editParams: {
      },
    };
  },
  computed: {
    detailParams () {
      return {
        orgId: this.$route.query.id,
      };
    },
  },
  methods: {
    detailApi: orgDetail,
    editApi: orgEdit,
  },
  async mounted () {
    await this.$refs.baseForm.getList();
    this.getData();
  },
};
</script>

<style scoped lang="scss">
</style>
